import { Fragment } from "react";
import { Header } from "../../components/header";
import SideBar from "./SldeBar";
import { Box } from "../../components";
import ConfigContent from "./Content";
import { useSearchParams } from "../../hook/use-search-params";
import { ConfigId, configTitles } from "./constanst/box-title";

function getConfigTitle(configId: ConfigId): string {
  return configTitles[configId] || "🤵‍♂️ Cấu hình danh sách nhân viên"; // Default title
}

export const ConfigProcedure = () => {
  const { searchParams } = useSearchParams();
  const configId = searchParams.get("configId") || "1";
  const configTitle = getConfigTitle(configId as ConfigId);

  return (
    <Fragment>
      <Header />
      <Box title={"Cấu hình E-OFFICE"}>
        <div className="flex" style={{ gap: "12px", alignItems: "flex-start" }}>
          <SideBar />
          <div style={{ overflowX: "auto", flex: 1 }}>
            <Box title={configTitle}>
              <ConfigContent />
            </Box>
          </div>
        </div>
      </Box>
    </Fragment>
  );
};
